import React, { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import ApiManager from '../../ApiManager/ApiManager';
import './NewRole.css';
import PermissionsGrid from '../../components/PermissionGrid/PermissionsGrid';


const NewRole = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [name, setName] = useState("");
    const [description , setDescription] = useState("");
    const [data, setData] = useState([]);
    const [selectedPermissionGroups, setSelectedPermissionGroups] = useState([]);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const saveRole = async () => {
        try {
            const payload = {
                role: {
                    name: name,
                    description: description
                  },
                permissions: selectedPermissionGroups
            };
            const response = await ApiManager.addRole(payload);
            if (!response.ok) throw new Error('Network response was not ok');
        } catch (error) {
            console.log('error',error);
        }
        setModalOpen(!isModalOpen);
    };
    return (
        <div className="new-role">
                <button className="custom-button" onClick={toggleModal}>
                    New Role
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <form >
                        <label htmlFor="name">Name:</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            onChange={handleNameChange}
                        />
                        <label htmlFor="description">Description:</label>
                        <input
                            type="text"
                            id="description"
                            name="description"
                            onChange={handleDescriptionChange}
                        />
                    </form>
                    <PermissionsGrid 
                        setSelectedPermissionGroups={setSelectedPermissionGroups}
                    />
                    <div className="newCar-bar">
                    <button className="newCar-button" onClick={saveRole} style={{float:"right"}}>
                        Save
                    </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default NewRole;
